import { render } from "./StaffPage_setting.vue?vue&type=template&id=1f7e9cfd&scoped=true"
import script from "./StaffPage_setting.vue?vue&type=script&lang=js"
export * from "./StaffPage_setting.vue?vue&type=script&lang=js"

import "./StaffPage_setting.vue?vue&type=style&index=0&id=1f7e9cfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7e9cfd"]])

export default __exports__